import { Chip, Stack } from '@mui/material';
import { Specialty } from '../../../generated/graphql';

type PropTypes = {
  specialties: Specialty[];
};

export const Specialties = ({ specialties }: PropTypes) =>
  specialties.length && (
    <Stack direction="row" flexWrap="wrap" spacing={1} sx={{ mb: 3 }}>
      {specialties.map((specialty, index) => (
        <Chip key={index} label={specialty.name} size="small" />
      ))}
    </Stack>
  );
